import type { Table } from '@tanstack/react-table';

import type { UserPublicTokenType } from '@/utils/hooks/swr/integrations/useUserPublicTokens';

function TablePlaceholder({ table }: { table: Table<UserPublicTokenType> }) {
    return (
        <tbody data-testid="table-body-placeholder">
            {[...new Array(5)].map((_, rowIndex) => {
                return (
                    <tr
                        key={rowIndex}
                        className="h-15 animate-pulse bg-icoGray-100 dark:bg-icoDarkMode-deepBlack">
                        {table.getVisibleLeafColumns().map((column) => {
                            return <td key={column.id} />;
                        })}
                        <td />
                    </tr>
                );
            })}
        </tbody>
    );
}

export default TablePlaceholder;
